import { Injectable } from "@angular/core";
import { ApiEndPoint } from "./api-end-point";
import { ApiResultError, CheckUtils } from "..";
var UsersEndPoints = /** @class */ (function () {
    function UsersEndPoints(apiEndPoint) {
        this.apiEndPoint = apiEndPoint;
    }
    UsersEndPoints.prototype.get = function (jabberIds) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(jabberIds)) {
                return resolve([]);
            }
            _this.apiEndPoint.post('user/userDescriptions', jabberIds).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    UsersEndPoints.prototype.getByJid = function (jabberIds) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (CheckUtils.isEmpty(jabberIds)) {
                return resolve([]);
            }
            else {
                var index = jabberIds.findIndex(function (jabberId) { return "admin" === jabberId; });
                if (index != -1) {
                    jabberIds.splice(index, 1);
                    if (CheckUtils.isEmpty(jabberIds))
                        return resolve([]);
                }
            }
            _this.apiEndPoint.post('conversations/usersByJabberIds', jabberIds).subscribe(function (res) {
                if (res instanceof ApiResultError) {
                    reject(res);
                }
                else {
                    resolve(res);
                }
            });
        });
    };
    UsersEndPoints.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    UsersEndPoints.ctorParameters = function () { return [
        { type: ApiEndPoint, },
    ]; };
    return UsersEndPoints;
}());
export { UsersEndPoints };
//# sourceMappingURL=users-end-points.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/endpoints/users-end-points.js
// module id = 347
// module chunks = 14